module.exports = require("@material-ui/icons/Fullscreen");